import { useEffect } from 'react'
import { useTrackReady } from '@adsk/exo-skeleton-react'
import type { PerformanceTrackingProps } from './types'
import { isInExoSkeleton } from '@adsk/exo-skeleton-api'

// https://git.autodesk.com/BIM360/acs-sc-web-platform/tree/master/libs/exo-skeleton-react#performance-tracking
export const useExoTrackReadyPagePerformance = ({
	displayName,
	isLoading,
}: PerformanceTrackingProps): void => {
	// For local development, we're not using EXO framework.
	// The useTrackReady won't be available. Added a protection here and also check it inside effect.
	const isExo = isInExoSkeleton()
	const { trackReadyOnce } = useTrackReady() ?? {}
	useEffect(() => {
		const shouldReportDetails = (isExo &&
			!isLoading &&
			trackReadyOnce) as unknown as boolean
		if (shouldReportDetails) {
			console.log(`Tracking started using useTrackPagePerformance custom hook`)
			trackReadyOnce({ metadata: { displayName } })
			console.log(
				`Reports were reported using useTrackPagePerformance custom hook`
			)
		}
	}, [trackReadyOnce, isLoading])
}
